export enum Types {
	Error = 'error',
	NotFound = '404',
	Warning = 'warning',
}
